import { render } from "./AcademicSchedule.vue?vue&type=template&id=2330010c&scoped=true"
import script from "./AcademicSchedule.vue?vue&type=script&lang=js"
export * from "./AcademicSchedule.vue?vue&type=script&lang=js"

import "./AcademicSchedule.vue?vue&type=style&index=0&id=2330010c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2330010c"]])

export default __exports__